import {
  callApiGetLoaiNhiemVu,
  callApiGetTatCaLoaiNhiemVu,
  callApiGetNhiemVuPaging,
  callApiGetTatCaDonViTrongDonViCha,
  callApiLayChiTietNhiemVu,
  callApiTaoNhiemVu,
  callApiThemYKienNhiemVu,
  callApiGetTatCaCanBoTrongDonVi,
  callApiThuHoiNhiemVu,
  callApiLayDanhSachThuHoiNhiemVu,
  callApiTraLaiNhiemVu,
  callApiCapNhatNhiemVu,
  callApiLayDanhSachTraLaiNhiemVu,
  callApiDonDocNhiemVu,
  callApiCapNhatTinhHinhNhiemVu,
  callApiGetTatCaCanBoCoQuyenPhanXuLy,
  callApiLayDanhSachSoLuongNhiemVu,
  callApiTaoVanBanLienQuan,
  callApiUploadFile,
  callApiThemMoiYKien,
  callApiLayDanhSachNguoiGiaoNhiemVu,
  callApiLayDanhSachNhiemVu,
  callApiGetTrangThai,
  callApiGetDonViCaNhan,
  callApiLayChiTietYKienXuLy,
  callApiLayChiTietVanBanLienQuan,
  callApiPhanXuLy,
  callApiGetPhanXuLyByNhiemVuId,
  callApiUpdatePhanXuLy,
  callApiGetDonViXuLy,
  callApiGetDonViXuLyES,
  callApiGetDonViXuLyChildren2,
  callApiGetDonViXuLyNew,
  callApiCapNhatVanBanLienQuanNhiemVu,
  callApiThemVBLQTinhHinhThucHien,
  callApiCapNhatYKienXuLyNhiemVu,
  callApiGetLichSuPhanXuLy,
  callApiLayTrangThaiTinhHinhThucHien,
  callApiThemMoiTinhHinhThucHien,
  callApiCapNhatVBLQTinhHinhThucHien,
  callApiLayTinhHinhThucHienNhiemVu,
  callApiLayTinhHinhThucHienCongViec,
  callApiUploadOneFile,
  callApiLayPhuongThucNhanNhiemVu,
  callApiLayDanhSachLichSuTraLaiNhiemVu,
  callApiLayDanhSachLichSuCapNhatTinhHinhNhiemVu,
  callApiLayDanhSachLichSuVPCPDonDoc,
  callApiLayDanhSachLichSuVPCPTienDo,
  callApiLayDanhSachLichSuVPCPDieuChinh,
  callApiLayDanhSachLichSuGuiTraVPCP,
  callApiLayDanhSachLichSuThuHoiNhiemVu,
  callApiLayDanhSachLichSuDonDocNhiemVu,
  callApiTraLaiNhiemVuVPCP,
  callApiLayDanhSachDemLoaiCongViec,
  callApiLayDanhSachSoDoLuongNhiemVu,
  callApiLayDanhSachSoDoLuongNhiemVuToken,
  callApiGetExportNhiemVu,
  callApiLayDanhSachDemLoaiNhiemVuCaNhan,
  callApiLayDanhSachDemLoaiNhiemVuDonVi,
  callApiLayDanhSachDemLoaiCongViecDonVi,
  callApiLayDanhSachDemLoaiCongViecDV,
  callApiXoaNhiemVu,
  callApiGetDanhSachNhiemVuFromImportFile,
  callApiKiemThuFileImportNhiemVu,
  callApiImportNhiemVu,
  callApiGuiLaiVPCPNhiemVu,
  callApiGetCotNhiemVuExport,
  callApiGetDanhSachNhiemVuExportTemplate,
  callApiThemMoiExportTemplate,
  callApiLayDanhSachPhamVi,
  callApiSuaYKienNhiemVu,
  callApiXoaYKienNhiemVu,
  callApiDownloadFileExport,
  callApiGetTaskPhanXuLyId,
  callApiTraLaiCongViec,
  callApiDanhSachDonViNhiemVuPhanXuLy,
  callApiLayDanhSachSoDoLuongNhiemVuV2,
  callApiLayTrangThaiChoDuyetHoanThanh,
  callApiCapNhatTuDongHoanThanh,
  callApiYeuCauGiaHanVPCP,
  callApiUpdateVanBanLienQuan,
  callApiLayDanhSachThuHoiCongViec,
} from "@/api/nhiem-vu";
import Vue from "vue";

const uploadOneFile = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiUploadOneFile(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const updatePhanXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiUpdatePhanXuLy(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getPhanXuLyByNhiemVuId = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetPhanXuLyByNhiemVuId(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDonViXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDonViXuLy(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_TAT_CA_DON_VI", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDonViXuLyES = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDonViXuLyES(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_TAT_CA_DON_VI", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDonViXuLyESCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDonViXuLyES(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const callExpendDonViXuLyES = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDonViXuLyES(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};


const getDonViXuLyChildren2 = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDonViXuLyChildren2(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_TAT_CA_DON_VI", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDonViXuLyNew = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDonViXuLyNew(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_TAT_CA_DON_VI", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layNhiemVuPaging = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetNhiemVuPaging(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_NHIEM_VU_PAGING", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layTatCaDonViTrongDonViCha = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetTatCaDonViTrongDonViCha(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_TAT_CA_DON_VI_TRONG_DON_VI_CHA", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layTatCaCanBoTronDonVi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetTatCaCanBoTrongDonVi(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_TAT_CA_CAN_BO_TRONG_DON_VI", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layTatCaCanBoCoQuyenPhanXuLyTrongDonVi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetTatCaCanBoCoQuyenPhanXuLy(payload)
      .then((response) => {
        if (response) {
          context.commit(
            "SET_TAT_CA_CAN_BO_CO_QUYEN_PHAN_XU_LY_TRONG_DON_VI",
            response.data
          );
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layTatCaLoaiNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetLoaiNhiemVu(payload)
      .then((response) => {
        if (response) {
          context.commit("LAY_LOAI_NHIEM_VU", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layTatCaLoaiNhiemVuKhongPhanQuyen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetTatCaLoaiNhiemVu(payload)
      .then((response) => {
        if (response) {
          context.commit("LAY_TAT_CA_LOAI_NHIEM_VU", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const taoNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTaoNhiemVu(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const phanXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiPhanXuLy(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const capNhatTuDongHoanThanh = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatTuDongHoanThanh(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const taoVanBanLienQuan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTaoVanBanLienQuan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const themMoiFile = (context, payload) => {
  return new Promise((resolve) => {
    callApiUploadFile(payload)
      .then((response) => {
        if (!response.data.IsSuccess) {
          Vue.toasted.global.showErrorMessage({
            message: response.data.Messages[0],
          });
        }
        resolve(response);
      })
      .catch((error) => {
        Vue.toasted.global.showErrorMessage({
          message: error,
        });
      });
  });
};

const themMoiYkienNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemMoiYKien(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachNguoiGiaoNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachNguoiGiaoNhiemVu(payload)
      .then((response) => {
        if (response) {
          context.commit("LAY_DANH_SACH_NGUOI_GIAO_NHIEM_VU", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layChiTietNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayChiTietNhiemVu(payload)
      .then((response) => {
        if (response) {
          context.commit("LAY_CHI_TIET_NHIEM_VU_THANH_CONG", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layChiTietVanBanLienQuanNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayChiTietVanBanLienQuan(payload)
      .then((response) => {
        if (response) {
          context.commit("LAY_CHI_TIET_VAN_BAN_LIEN_QUAN", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layChiTietYKienNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayChiTietYKienXuLy(payload)
      .then((response) => {
        if (response) {
          context.commit("LAY_CHI_TIET_Y_KIEN_XU_LY", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const capNhatNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatNhiemVu(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

const capNhatVanBanLienQuanNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatVanBanLienQuanNhiemVu(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

const capNhatYKienXuLyNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatYKienXuLyNhiemVu(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

const themYKienNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemYKienNhiemVu(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

const thuHoiNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThuHoiNhiemVu(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

const layDanhSachthuHoiNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachThuHoiNhiemVu(payload)
      .then((response) => {
        if (response) {
          context.commit("LAY_DANH_SACH_THU_HOI_NHIEM_VU", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

const layDanhSachThuHoiCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachThuHoiCongViec(payload)
        .then((response) => {
          if (response) {
            context.commit("LAY_DANH_SACH_THU_HOI_NHIEM_VU", response.data);
          }
          resolve(response);
        })
        .catch((error) => {
          console.error(error);
          reject(error);
        });
  });
};

const traLaiNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTraLaiNhiemVu(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachTraLaiNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachTraLaiNhiemVu(payload)
      .then((response) => {
        if (response) {
          context.commit("LAY_DANH_SACH_TRA_LAI_NHIEM_VU", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

const donDocNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiDonDocNhiemVu(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const capNhatTinhHinhNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatTinhHinhNhiemVu(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const laySoLuongNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachSoLuongNhiemVu(payload)
      .then((response) => {
        if (response) {
          context.commit("LAY_DANH_SACH_TRA_SO_LUONG_NHIEM_VU", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachNhiemVu = (context, payload) => {
  context.commit("SET_DANH_SACH_NHIEM_VU", []);
  return new Promise((resolve, reject) => {
    callApiLayDanhSachNhiemVu(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_NHIEM_VU", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("SET_DANH_SACH_NHIEM_VU", []);
        reject(error);
      });
  });
};

const layDanhSachLichSuPhanXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetLichSuPhanXuLy(payload)
      .then((response) => {
        if (response) {
          context.commit("LAY_DANH_SACH_LICH_SU_PHAN_XU_LY", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachTrangThai = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetTrangThai(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_TRANG_THAI", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachDonViCaNhan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDonViCaNhan(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_DON_VI_CA_NHAN", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layTrangThaiTinhHinhThucHien = (context) => {
  return new Promise((resolve, reject) => {
    callApiLayTrangThaiTinhHinhThucHien()
      .then((response) => {
        if (response) {
          context.commit("SET_TRANG_THAI_TINH_HINH_THUC_HIEN", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layTrangThaiChoDuyetHoanThanh = (context) => {
  return new Promise((resolve, reject) => {
    callApiLayTrangThaiChoDuyetHoanThanh()
      .then((response) => {
        if (response) {
          context.commit("SET_TRANG_THAI_TINH_HINH_THUC_HIEN", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const themMoiTinhHinhNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemMoiTinhHinhThucHien(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const capNhatVBLQTinhHinhNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatVBLQTinhHinhThucHien(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const themVBLQTinhHinhThucHien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemVBLQTinhHinhThucHien(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachTinhHinhThucHienNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayTinhHinhThucHienNhiemVu(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachTinhHinhThucHienCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayTinhHinhThucHienCongViec(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachPhuongThucNhanNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayPhuongThucNhanNhiemVu(payload)
      .then((response) => {
        if (response) {
          context.commit(
            "SET_DANH_SACH_PHUONG_THUC_NHAN_NHIEM_VU",
            response.data
          );
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachLichSuTraLaiNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachLichSuTraLaiNhiemVu(payload)
      .then((response) => {
        if (response) {
          context.commit(
            "SET_DANH_SACH_LICH_SU_TRA_LAI_NHIEM_VU",
            response.data
          );
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachLichSuCapNhatTinhHinhNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachLichSuCapNhatTinhHinhNhiemVu(payload)
      .then((response) => {
        if (response) {
          context.commit(
            "SET_DANH_SACH_LICH_SU_CAP_NHAT_TINH_HINH_NHIEM_VU",
            response.data
          );
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const danhSachVPCPDonDocNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachLichSuVPCPDonDoc(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const danhSachVPCPTienDoXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachLichSuVPCPTienDo(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const danhSachVPCPDieuChinhNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachLichSuVPCPDieuChinh(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const danhSachGuiTraVPCP = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachLichSuGuiTraVPCP(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};


const layDanhSachLichSuThuHoiNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachLichSuThuHoiNhiemVu(payload)
      .then((response) => {
        if (response) {
          context.commit(
            "SET_DANH_SACH_LICH_SU_THU_HOI_NHIEM_VU",
            response.data
          );
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachLichSuDonDocNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachLichSuDonDocNhiemVu(payload)
      .then((response) => {
        if (response) {
          context.commit(
            "SET_DANH_SACH_LICH_SU_DON_DOC_NHIEM_VU",
            response.data
          );
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const traLaiNhiemVuVanPhongChinhPhu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTraLaiNhiemVuVPCP(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachDemLoaiNhiemVuCaNhan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachDemLoaiNhiemVuCaNhan(payload)
      .then((response) => {
        if (response) {
          context.commit(
            "SET_DANH_SACH_DEM_LOAI_NHIEM_VU_CA_NHAN",
            response.data
          );
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachDemLoaiNhiemVuDonVi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachDemLoaiNhiemVuDonVi(payload)
      .then((response) => {
        if (response) {
          context.commit(
            "SET_DANH_SACH_DEM_LOAI_NHIEM_VU_DON_VI",
            response.data
          );
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachDemLoaiCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachDemLoaiCongViec(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_DEM_LOAI_CONG_VIEC", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachDemLoaiCongViecDonVi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachDemLoaiCongViecDonVi(payload)
      .then((response) => {
        if (response) {
          context.commit(
            "SET_DANH_SACH_DEM_LOAI_CONG_VIEC_DON_VI",
            response.data
          );
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachDemLoaiCongViecDV = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachDemLoaiCongViecDV(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_DEM_LOAI_CONG_VIEC_DV", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const setDanhSachSoDoLuongNhiemVu = (context, response) => {
  if (response) {
    context.commit("SET_DANH_SACH_SO_DO_LUONG_NHIEM_VU", response.data);
  }
}

const layDanhSachSoDoLuongNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachSoDoLuongNhiemVu(payload)
      .then((response) => {
        setDanhSachSoDoLuongNhiemVu(context, response);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachSoDoLuongNhiemVuV2 = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachSoDoLuongNhiemVuV2(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachSoDoLuongNhiemVuToken = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachSoDoLuongNhiemVuToken(payload)
      .then((response) => {
        setDanhSachSoDoLuongNhiemVu(context, response);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// eslint-disable-next-line no-unused-vars
const clearDanhSachLuongXuLy = (context, payload) => {
  context.commit("SET_DANH_SACH_SO_DO_LUONG_NHIEM_VU", []);
}

const getExportNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetExportNhiemVu(payload)
      .then((response) => {
        if (response) {
          context.commit(
            "SET_KET_QUA_EXPORT_DANH_SACH_NHIEM_VU",
            response.data
          );
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const downloadFileExport = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiDownloadFileExport(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const xoaNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaNhiemVu(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDanhSachNhiemVuFromImportFile = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachNhiemVuFromImportFile(payload)
      .then((response) => {
        if (response) {
          context.commit(
            "SET_DANH_SACH_NHIEM_VU_FROM_IMPORT_FILE",
            response.data
          );
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const kiemThuFileImportNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiKiemThuFileImportNhiemVu(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const importNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiImportNhiemVu(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDanhSachCotNhiemVuExport = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetCotNhiemVuExport(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDanhSachNhiemVuExportTemplate = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachNhiemVuExportTemplate(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const themMoiExportTemplate = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemMoiExportTemplate(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachCotNhiemVu = (context, payload) => {
  context.commit("SET_DANH_SACH_COT_NHIEM_VU", payload);
};

const layDanhSachCotDanhMuc = (context, payload) => {
  context.commit("SET_DANH_SACH_COT_DANH_MUC", payload);
};

const capNhatDanhSachCotNhiemVu = (context, payload) => {
  context.commit("CAP_NHAT_DANH_SACH_COT_NHIEM_VU", payload);
};

const capNhatDanhSachCotDanhMuc = (context, payload) => {
  context.commit("CAP_NHAT_DANH_SACH_COT_DANH_MUC", payload);
};

const guiLaiVPCPNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGuiLaiVPCPNhiemVu(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachPhamVi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachPhamVi(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const suaYKienNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaYKienNhiemVu(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const XoaYKienNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaYKienNhiemVu(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const getTaskPhanXuLyId = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetTaskPhanXuLyId(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDanhSachDonViPhanXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiDanhSachDonViNhiemVuPhanXuLy(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const traLaiCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTraLaiCongViec(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const yeuCauGiaHanVPCP = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiYeuCauGiaHanVPCP(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const updateVanBanLienQuan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiUpdateVanBanLienQuan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default {
  traLaiCongViec,
  getDonViXuLyNew,
  getDanhSachDonViPhanXuLy,
  callExpendDonViXuLyES,
  layNhiemVuPaging,
  taoNhiemVu,
  phanXuLy,
  capNhatTuDongHoanThanh,
  getPhanXuLyByNhiemVuId,
  getDonViXuLy,
  getDonViXuLyES,
  getDonViXuLyChildren2,
  updatePhanXuLy,
  capNhatNhiemVu,
  xoaNhiemVu,
  layTatCaDonViTrongDonViCha,
  layChiTietNhiemVu,
  layTatCaLoaiNhiemVu,
  layTatCaLoaiNhiemVuKhongPhanQuyen,
  themYKienNhiemVu,
  layTatCaCanBoTronDonVi,
  thuHoiNhiemVu,
  layDanhSachthuHoiNhiemVu,
  traLaiNhiemVu,
  layDanhSachTraLaiNhiemVu,
  donDocNhiemVu,
  capNhatTinhHinhNhiemVu,
  layTatCaCanBoCoQuyenPhanXuLyTrongDonVi,
  laySoLuongNhiemVu,
  taoVanBanLienQuan,
  themMoiFile,
  themMoiYkienNhiemVu,
  layDanhSachNguoiGiaoNhiemVu,
  layDanhSachNhiemVu,
  layDanhSachTrangThai,
  layDanhSachDonViCaNhan,
  layChiTietYKienNhiemVu,
  layChiTietVanBanLienQuanNhiemVu,
  capNhatVanBanLienQuanNhiemVu,
  capNhatYKienXuLyNhiemVu,
  layDanhSachLichSuPhanXuLy,
  layTrangThaiTinhHinhThucHien,
  layTrangThaiChoDuyetHoanThanh,
  themMoiTinhHinhNhiemVu,
  capNhatVBLQTinhHinhNhiemVu,
  themVBLQTinhHinhThucHien,
  layDanhSachTinhHinhThucHienNhiemVu,
  layDanhSachTinhHinhThucHienCongViec,
  uploadOneFile,
  layDanhSachPhuongThucNhanNhiemVu,
  layDanhSachLichSuTraLaiNhiemVu,
  layDanhSachLichSuCapNhatTinhHinhNhiemVu,
  layDanhSachLichSuThuHoiNhiemVu,
  layDanhSachLichSuDonDocNhiemVu,
  traLaiNhiemVuVanPhongChinhPhu,
  layDanhSachDemLoaiNhiemVuCaNhan,
  layDanhSachDemLoaiNhiemVuDonVi,
  layDanhSachDemLoaiCongViec,
  layDanhSachSoDoLuongNhiemVu,
  layDanhSachSoDoLuongNhiemVuV2,
  layDanhSachDemLoaiCongViecDonVi,
  layDanhSachDemLoaiCongViecDV,
  getExportNhiemVu,
  downloadFileExport,
  importNhiemVu,
  getDanhSachCotNhiemVuExport,
  getDanhSachNhiemVuExportTemplate,
  layDanhSachCotNhiemVu,
  capNhatDanhSachCotNhiemVu,
  capNhatDanhSachCotDanhMuc,
  layDanhSachCotDanhMuc,
  guiLaiVPCPNhiemVu,
  getDanhSachNhiemVuFromImportFile,
  kiemThuFileImportNhiemVu,
  themMoiExportTemplate,
  layDanhSachPhamVi,
  suaYKienNhiemVu,
  XoaYKienNhiemVu,
  getTaskPhanXuLyId,
  clearDanhSachLuongXuLy, layDanhSachSoDoLuongNhiemVuToken , yeuCauGiaHanVPCP, updateVanBanLienQuan, danhSachVPCPDonDocNhiemVu,
  danhSachGuiTraVPCP, danhSachVPCPTienDoXuLy, danhSachVPCPDieuChinhNhiemVu,
  getDonViXuLyESCongViec,
  layDanhSachThuHoiCongViec,
};
